<div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">
        {{ (category.id ? 'bikeshop.rentals.category.edit_category' : 'bikeshop.rentals.category.add_category') | translate
        }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span class="hubtiger-close"></span>
    </button>
</div>
<div class="modal-body">


    <div>
        <div class="row margin-top-8">
            <div class="col-md-4 label" [ngClass]="{ 'red' : !category.categoryName}">{{
                'bikeshop.rentals.category.category_name' | translate }}:
            </div>
            <div class="col-md-8">
                <input type="text" pInputText [(ngModel)]="category.categoryName"/>
            </div>
        </div>
        <div class="row margin-top-8" *ngIf="allowSecurityDeposit">
            <div class="col-md-4 label">{{
                'bikeshop.rentals.configuration.take_security_deposit' | translate }}</div>
            <div class="col-md-2">
                <p-inputSwitch [(ngModel)]="category.deductSecurityDeposit"></p-inputSwitch>
            </div>
        </div>
        <div class="row margin-top-8" *ngIf="allowSecurityDeposit && category.deductSecurityDeposit">
            <div class="col-md-4 label" [ngClass]="{ 'red' : !category.securityDepositAmount}">{{
                'bikeshop.rentals.categories.security_deposit_amount' | translate }}:
            </div>
            <div class="col-md-3">
                <!-- <p-autoComplete [(ngModel)]="category.newSku" field="SKU" [suggestions]="searchResult" placeholder="{{
                  'bikeshop.modal.add_edit_service_types.linked_skus_form.enter_sku_or_name'
                    | translate
                }}" (completeMethod)="searchProducts($event)"
                  (onSelect)="linkSku(category.newSku)" [disabled]="busy">
                  <ng-template let-product pTemplate="item">
                    <div>
                      <span>{{ product.SKU }} - {{ product.Name }}</span>
                    </div>
                  </ng-template>
                </p-autoComplete> -->
                <div class="p-inputgroup">
                    <span class="p-inputgroup-addon"><i>{{partner.CurrencySymbol}}</i></span>
                    <input type="number" pInputText [(ngModel)]="category.securityDepositAmount"/>
                </div>
            </div>
        </div>
        <!-- <div class="row margin-top-8" *ngIf="allowSecurityDeposit && category.deductSecurityDeposit && category.internalProductID">
          <div class="col-md-4"></div>
          <div class="col-md-7 linked-sku-message">
            <div>{{category.sku}}</div>
            <div>{{category.name}}</div>
            <div *ngIf="category.rate"><span>{{category.amount | currency : category.currencySymbol}}</span></div>
          </div>
          <div class="col-md-1 flex"><span class="fa fa-trash" (click)="removeSKU()"></span></div>
        </div> -->

    </div>
</div>
<div class="modal-footer">
    <div class="row margin-top-8">
        <div class="col-md-6">
            <button pButton type="button" class="p-button-raised alternate full-width" *ngIf="category.id"
                    label="{{'bikeshop.rentals.category.remove_category' | translate}}" (click)="removeCategory()"
                    [disabled]="busy"></button>
        </div>
        <div class="col-md-6">
            <button pButton type="button" class="p-button-raised full-width"
                    label="{{'bikeshop.rentals.category.save_category' | translate}}" (click)="saveCategory()"
                    [disabled]="busy || !valid()"></button>
        </div>
    </div>
</div>
<p-confirmDialog></p-confirmDialog>
